<style>
  input, label {
    margin: 0.2em;
    cursor: pointer;
  }
  p {
    margin-right: 0em;
  }
  .contents {
    margin: -0.4em 0.6em 0.4em 0.6em; /* top | right | bottom | left */
  }
  .item {
    margin: 0.2em;
    align-items: center;
  }
  .widget {
    margin: 0.2em;
  }
</style>

<script>
  import config from '../../config';
  import { config_values, open_config_widget } from '../store';
  
  function toggle_open_config_widget() {
    if ($open_config_widget === widget_id) {
      $open_config_widget = '';
    } else {
      $open_config_widget = widget_id;
    };
  }
  
  export let widget_id;
  let params = config.config_widgets[widget_id];
  
  // filling in configuration dictionary
  if (!$config_values[widget_id]) {
    $config_values[widget_id] = params.default;
  }
</script>

<div class='widget vertical show-border'>
  {#if params.togglable}
    <div class='caption-center horiz-always togglable unselectable' on:click={toggle_open_config_widget}>
      <p>{params.caption}</p>
      <!-- <div class='filler'></div> -->
      {#if $open_config_widget === widget_id}
        <p class='small'>[–]</p>
      {:else}
        <p class='small'>[+]</p>
      {/if}
    </div>
  {:else}
    <div class='caption-center horiz-always unselectable'>
      <p>{params.caption}</p>
    </div>
  {/if}
  {#if !params.togglable || $open_config_widget === widget_id}
    <div class='contents horiz-always'>
      <select id={widget_id} bind:value={$config_values[widget_id].chosen}>
        {#each Object.keys($config_values[widget_id].choices).sort() as key}
          <option value={key}>{$config_values[widget_id].choices[key].name}</option>
        {/each}
      </select>
    </div>
  {/if}
</div>
